import styled from 'styled-components';

export const ManusPartContainer = styled.div<{ highlighted: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 5px;
  border-bottom: 1px dotted #aaa;
  cursor: grab;
  background-color: ${(p) => (p.highlighted ? '#ccc' : 'inherit')};
  user-select: none;
`;

export const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 1.5em;
    padding-top: 2px;
    padding-right: 5px;
`;

export const EntryNumber = styled.div`
    font-weight: bold;
    line-height: 1.2;
    margin-bottom: 2px;
`;

export const NoSpeak = styled.div`
  font-style: italic;
  color: grey;
`;
